import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { map, filter, take } from 'rxjs';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService: AuthService = inject(AuthService);
  const router = inject(Router);

  console.log('Auth guard checking auth state for URL:', state.url, {
    isLoading: authService.isLoading(),
    isAuthenticated: authService.isAuthenticated()
  });

  // If not loading, make immediate decision
  if (!authService.isLoading()) {
    if (authService.isAuthenticated()) {
      console.log('Auth guard: User is authenticated, allowing navigation');
      return true;
    } else {
      console.log('Auth guard: User is not authenticated, redirecting to login');
      router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url },
        replaceUrl: true
      });
      return false;
    }
  }

  // If loading, wait for auth state to be determined
  console.log('Auth guard: Auth state is loading, waiting for resolution');
  return authService.isLoading$.pipe(
    filter(isLoading => !isLoading), // Wait until loading is false
    take(1), // Take only the first emission
    map(() => {
      if (authService.isAuthenticated()) {
        console.log('Auth guard: Auth resolved - user is authenticated, allowing navigation');
        return true;
      } else {
        console.log('Auth guard: Auth resolved - user is not authenticated, redirecting to login');
        router.navigate(['/auth/login'], {
          queryParams: { returnUrl: state.url },
          replaceUrl: true
        });
        return false;
      }
    })
  );
};
